import SearchByCountry from './components/search-by-country';
import SearchById from './components/search-by-id';
import Home from './components/home';
import Authentication from './components/authentication';
import CoinDetails from './components/coin-details';
import Collection from './components/collection';
import AdminImportCoins from './components/admin/admin-import-coins';
import AdminHome from './components/admin/admin-home';
import VueRouter from 'vue-router';
import Credit from './components/credit';

const router = [
  { name: '', path: '/', component: Home },
  { name: 'home', path: '/home', component: Home },
  { name: 'credit', path: '/credit', component: Credit },
  { name: 'search-by-country', path: '/search-by-country', component: SearchByCountry, meta: { requireAuth: true } },
  { name: 'search-by-id', path: '/search-by-id', component: SearchById, meta: { requireAuth: true } },
  { name: 'details', path: '/details/:id', component: CoinDetails, meta: { requireAuth: true } },
  { name: 'login', path: '/login', component: Authentication, meta: { login: true } },
  { name: 'collection', path: '/collection', component: Collection, meta: { requireAuth: true } },
  { name: 'admin-home', path: '/admin', component: AdminHome, meta: { requireAuth: true } },
  { name: 'admin-coins', path: '/admin-coins', component: AdminImportCoins, meta: { requireAuth: true } },
];

export default new VueRouter({
  routes: router
});
